import React, { useEffect, useState } from 'react';
import { useToasts } from 'react-toast-notifications';
import { Row, Col, Button, ListGroup, ListGroupItem } from 'reactstrap';
import { ExpandableBox } from '@galop/component-library';
import { makeCall } from '../../auth-utils';
import { api, globalErrorHandler } from '../../api/create-api';
import { Field } from '@galop/component-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { GetOptionText } from '../../Helpers/Helper';
import Lock, { AppIsLocked } from '../Shared/Lock';

export const Program = (props) => {
    const ls = require('local-storage');
    const { index, program, RemoveProgram, eraPrograms, eraStatuses, updateProgram } = props;
    const editable = !AppIsLocked();

    return (props.Header ?
        <div className="px-3">
            <Row className="align-items-center">
                <Col>
                    Program
                </Col>
                <Col>
                    Status
                </Col>
                <Col>
                    Amount Requested
                </Col>
                <Col>
                    Amount Received
                </Col>
                <Col>
                    Date Received
                </Col>
            </Row>
        </div>
        :
        <div className={`${index % 2 && 'bg-light'} rounded p-2`}>
            <Row className="align-items-center">
                <Col>
                    <Field type="select" HideHelp HideLabel field="eraProgramId" fieldClassName={!GetOptionText(eraPrograms, program.eraProgramId, 'id', 'deleted') && !!program.eraProgramId ? '' : 'is-invalid'} value={program.eraProgramId} label="ERA Program" EnableInput={{ disabled: !editable }} onChange={(e) => updateProgram(e.target.name, e.target.value, program, index)}>
                        <option value="">Select a Program</option>
                        {(eraPrograms || []).filter(era => !era.deleted || era.id === program.eraProgramId).map(option => <option key={option.id} value={option.id} disabled={option.deleted}>{option.name}{option.deleted ? ' (deleted)' : null}</option>)}
                    </Field>
                </Col>
                <Col>
                    <Field type="select" HideHelp HideLabel fieldClassName={program.eraStatusId ? '' : 'is-invalid'} field="eraStatusId" value={program.eraStatusId} label="Status" EnableInput={{ disabled: !editable }} onChange={(e) => updateProgram(e.target.name, e.target.value, program, index)}>
                        <option value="">Select a Status</option>
                        {(eraStatuses || []).map(option => <option key={option.id} value={option.id}>{option.name}</option>)}
                    </Field>
                </Col>
                <Col>
                    {program.eraStatusId &&
                        <Field type="currency" HideHelp HideLabel fieldClassName="text-right" left unit="$" field="eraRequestedAmount" fieldClassName={program.eraRequestedAmount > 100000 ? 'is-invalid' : null} value={program.eraRequestedAmount} label="Requested Amount" EnableInput={{ disabled: !editable }} onValueChange={(values) => updateProgram('eraRequestedAmount', values.floatValue, program, index)} />
                    }
                </Col>
                <Col>
                    {program.eraStatusId && (GetOptionText(eraStatuses, program.eraStatusId, 'id', 'name') || '').includes('Received') &&
                        <Field type="currency" HideHelp HideLabel fieldClassName="text-right" left unit="$" field="eraReceivedAmount" fieldClassName={program.eraReceivedAmount > 100000 ? 'is-invalid' : null} value={program.eraReceivedAmount} label="Received Amount" EnableInput={{ disabled: !editable }} onValueChange={(values) => updateProgram('eraReceivedAmount', values.floatValue, program, index)} />
                    }
                </Col>
                <Col>
                    <div className="d-flex align-items-center">
                        <div className="flex-fill mr-3">
                            {program.eraStatusId && (GetOptionText(eraStatuses, program.eraStatusId, 'id', 'name') || '').includes('Received') &&
                                <Field type="date" HideHelp HideLabel minDate={ls('MinimumDate') || "9/1/2020"} field="eraDateReceived" fieldClassName={!program.eraDateReceived ? 'is-invalid' : null} value={program.eraDateReceived ? new Date(program.eraDateReceived) : null} label="Date Received" EnableInput={{ disabled: !editable }} onChange={(value) => updateProgram('eraDateReceived', value, program, index)} />
                            }
                        </div>
                        <Lock
                            unlocked={() =>
                                <div>
                                    <Button color="danger" size="sm" outline onClick={RemoveProgram}><FontAwesomeIcon icon={faTimes} /></Button>
                                </div>
                            }
                        />
                    </div>
                </Col>
            </Row>
            {program.error &&
                <div className="text-right text-danger">
                {program.error}
                </div>
            }
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/LeaseDetails/Program.js